"use client"

import { useState, useEffect } from "react"

import { CalculatedProductPrice } from "@lib/util/get-product-price"
import { useDisplayPaymentOptions } from "@modules/signup-and-order-flow/util/use-fetch-display-options"

import InstallmentOption from "./installmentOption"
import PulsingDots from "../common/PulsingDots"

interface InstallmentContainerProps {
  calculatedPrices: CalculatedProductPrice | null
  onInstallmentSelected: (installments?: number) => void
  preSelectedInstallment?: number
}

const InstallmentContainer = ({ onInstallmentSelected, calculatedPrices, preSelectedInstallment }: InstallmentContainerProps) => {
  const [selectedInstallment, setSelectedInstallment] = useState<number | undefined>(preSelectedInstallment)
  const { paymentOptions, isLoading, error } = useDisplayPaymentOptions(calculatedPrices?.variantPrice?.raw_calculated_price)

  useEffect(() => {
    setSelectedInstallment(preSelectedInstallment)
  }, [preSelectedInstallment])

  if (!paymentOptions || paymentOptions.length === 0 || isLoading) {
    return <PulsingDots />
  }

  if (error) {
    // its okay to fail silently since users can still chose a payment option at the end of the flow
    return null
  }

  const handleSelectOption = (installments: number) => {
    const newSelection = selectedInstallment === installments ? undefined : installments
    setSelectedInstallment(newSelection)
    onInstallmentSelected(newSelection)
  }

  return (
    <div className="py-2">
      <div className="space-y-4">
        {paymentOptions
          .filter((option) => (selectedInstallment ? option.installments === selectedInstallment : true))
          .map((option) => (
            <InstallmentOption
              key={option.uuid}
              option={option}
              isSelected={selectedInstallment === option.installments}
              onSelect={handleSelectOption}
            />
          ))}
      </div>
      <p className="mt-3 text-xs font-bold text-gray-500">*No incluyen costo de envío.</p>
    </div>
  )
}

export default InstallmentContainer
